import h from './helpers.js'
import { updateCart, addToCart } from './cart.js'

const Insurance = {
	
	// Shopify product ids for different insurance plans
	plans: {
		1: '39309838155910', // $1 insurance (the minimum)
		2: '39309838188678', // $2 insurance
		3: '39309838221446', // $3 insurance
		4: '39309838254214', // $4 insurance
		5: '39309838286982'  // $5 insurance (the max)
	},
	
	setup() {
		
		// Get elements
		const subtotalElement = document.querySelector('.js-subtotal strong')
		const checkbox = document.querySelector('.js-insurance-checkbox')
		
		// Stop if not present
		if (!subtotalElement) return
		
		// Get numerical value of subtotal
		let subtotal = subtotalElement.textContent
		subtotal = parseFloat(subtotal.replace(/[$,]/g,''))
		
		log({subtotal})
		
		let insurancePrice = Math.round(subtotal * .01)
		
		// Uncheck checkbox if price is less than $0.10
		if (insurancePrice <= .1) checkbox.setAttribute('checked', false)
		
		// Impose limits
		if (insurancePrice > 5) {
			insurancePrice = 5
		} else if (insurancePrice < 1) {
			insurancePrice = 1
		}
		
		// Add insurance price to page
		document.querySelector('.js-insurance-amount').textContent = insurancePrice
		
		// Attach action to checkout button
		h.on('click', '.js-checkout', Insurance.checkout)
		
	},
	
	async checkout(e) {
		
		e.preventDefault()
		
		// Loading indicator
		this.classList.add('disabled')
		this.value = 'Loading...'
		
		// Remove all other insurance packages from the cart
		await Insurance.clear()
		
		// Add sellected insurance
		await Insurance.add()
		
		// Submit form for real
		this.closest('form').submit()
		
	},
	
	// Removes other insurance plans from cart
	async clear() {
		let itemsToRemove = {}
		for (let key in Insurance.plans) itemsToRemove[Insurance.plans[key]] = 0
		const response = await updateCart(itemsToRemove)
		log('updateCart', response)
	},
	
	async add() {
		
		const checkbox = document.querySelector('.js-insurance-checkbox')
		const amountElement = document.querySelector('.js-insurance-amount')
		
		// Stop if checkbox isn't checked
		if (!checkbox.checked) {
			log('Insurance opted-out')
			return
		}
		
		let amount = amountElement.textContent
		let id = Insurance.plans[amount]
		let data = [{
			quantity: 1,
			id,
		}]
		
		const response = await addToCart(data)
		
		log({response})
		
		return
		
	}
}

export default Insurance
